import { flatten } from 'flat'
import { mergeNestedObjectsStructure } from './mergeNestedObjectsStructure'

export const processChartData = <T extends Record<string, unknown>>(
    data: T[],
    labelsMap: Record<string, string>, // Mapping of flattened data keys to human-readable labels
    xKey: string, // The key for the x-axis (e.g., 'name')
    options: {
        include: Array<string>
    } = {
        include: [],
    }
): Array<Record<string, unknown>> => {
    // Flatten each item in the data array using flat
    const flattenedData: Array<Record<string, unknown>> = data.map((item) =>
        flatten(item, { delimiter: '_' })
    )

    const mergedData = mergeNestedObjectsStructure(flattenedData)

    const keysToInclude = options.include.length
        ? options.include.slice()
        : Object.keys(mergedData)
    keysToInclude.push(xKey)

    const filteredData = flattenedData.map((obj) => {
        return Object.fromEntries(
            Object.entries(obj).filter(([key]) => keysToInclude.includes(key))
        )
    })

    // Generate the final chart data
    const chartData = filteredData.map((entry) => {
        const newEntry = Object.keys(entry).reduce<Record<string, unknown>>(
            (acc, key) => {
                const newKey = labelsMap[key] ?? key
                return key === xKey
                    ? acc
                    : Object.assign(acc, { [newKey]: entry[key] })
            },
            {}
        )

        return {
            [xKey]: entry[xKey],
            ...newEntry,
        } as Record<string, unknown>
    })

    return chartData
}
